import { render, staticRenderFns } from "./form-input-datepicker.component.vue?vue&type=template&id=63b2ae36&"
import script from "./form-input-datepicker.component.ts?vue&type=script&lang=ts&"
export * from "./form-input-datepicker.component.ts?vue&type=script&lang=ts&"
import style0 from "./form-input-datepicker.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports